import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IScreens } from '../Interfaces/IScreens';
import { RolesService } from '../services/roles-service';
import { SitesService } from '../services/sites-services';
import { PropertiesService } from '../services/properties-services';
import { IProperties } from '../Interfaces/IProperties';
import { ISites } from '../Interfaces/ISites';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styles: [
  ]
})
export class ReportsComponent implements OnInit {

  loading = false;
  incidentsReport:any;
  sites = '';
  buildings = '';

  constructor(
    private siteService: SitesService,
		public translate: TranslateApplicationService,
		public notificationService: NotificationService,
		public dialog: MatDialog,
		public router: Router,
		private roleService: RolesService,
    private propertiesService: PropertiesService
  ) {

  }

  ngOnInit(): void {
    this.loading = true;
		this.roleService.EmployeeHasPermissionToScreen('Reports').subscribe(
    (result: TransactionResult<IScreens[]>) => {
      this.loading = false;
      if (result.success) {
        if (result.data == null || result.data.length == 0)
          this.router.navigateByUrl('/main/without-permission');
      }
      else{
				this.ErrorMessage('ROLES.Error_employee_has_permission');
				this.router.navigateByUrl('/main/without-permission');
			}
    },
    (error: any) => { 
      this.ErrorAlert(error); this.loading = false; 
    });
    this.propertiesService.GetPropertyByName('INCIDENTS_REPORT').subscribe(
    (result: TransactionResult<IProperties[]>) => {
      if (result.success) {
        this.incidentsReport = result.data[0].propertyvalue;
        this.propertiesService.GetPropertyByName('INCIDENTS_REPORT_FILTER').subscribe(
        (result: TransactionResult<IProperties[]>) => {
          if (result.success) {
            this.CreateSitesAndBuildingString(result); // Refactored function
          }
          else{
            this.loading = false;
            this.AlertProperties('Error','WARNINGS.Property_not_found','INCIDENTS_REPORT_FILTER');
          }
        },
        (error) => {
          this.ErrorAlert(error);
          this.loading = false;
        });
      }
      else{
        this.loading = false;
        this.AlertProperties('Error','WARNINGS.Property_not_found','INCIDENTS_REPORT');
      }
    },
    (error) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }

  private CreateSitesAndBuildingString(result: TransactionResult<IProperties[]>) {
    this.loading = true;
    this.siteService.GetSitesByUsername().subscribe(
    (resultSites: TransactionResult<ISites[]>) => {
      if (resultSites.success) {
        this.CreateSitesString(resultSites); // Refactored function
        this.siteService.GetSitesBuildingsByUsername(window.localStorage.getItem("username")).subscribe(
        (resultBuildings: TransactionResult<ISites[]>) => {
          this.loading = false;
          if (resultBuildings.success) {
            this.CreateBuildingString(resultBuildings, result); // Refactored function
          }
          else{
            this.ErrorAlert(result.message);
          }
        },
        (error) => {
          this.ErrorAlert(error);
          this.loading = false;
        });
      }
      else{
        this.ErrorAlert(result.message);
        this.loading = false;
      }
    },
    (error) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }

  private CreateBuildingString(resultBuildings: TransactionResult<ISites[]>, result: TransactionResult<IProperties[]>) {
    for (let i = 0; i < resultBuildings.data.length; i++) {
      if (resultBuildings.data[i].check == true && resultBuildings.data[i].building != '') {
        this.buildings += "'" + resultBuildings.data[i].building + (i < resultBuildings.data.length - 1 ? "'," : "'");
      }
    }
    if (this.buildings.charAt(this.buildings.length - 1) == ",") {
      this.buildings = this.buildings.substring(0, this.buildings.length - 1);
    }
    const urlFilter = result.data[0].propertyvalue.replace("{{sites}}", this.sites).replace("{{buildings}}", this.buildings);
    document.getElementById("iframe").setAttribute('src', this.incidentsReport + urlFilter);
  }

  private CreateSitesString(resultSites: TransactionResult<ISites[]>) {
    for (let i = 0; i < resultSites.data.length; i++) {
      this.sites += "'" + resultSites.data[i].site.trim() + (i < resultSites.data.length - 1 ? "'," : "'");
    }
  }

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
		  icon: 'all_inbox',
		  title: 'Error',
		  message: message,
		  shown: true,
		});
	}

  ErrorMessage(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}

  AlertProperties(title: string, message: string, property: string){
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: title,
      message: this.translate.TranslateKey(message) + ': ' + property,
      shown: true
    });
  }
}
